import React, { Component } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Table from './components/Table';
import SelectWrap from '../../components/SelectWrap';
import SyncMessage from "../../components/SyncMessage";
import API from '../../services/API';
import countriesObj from "../../data/countries";
import { handleFieldChange } from "../../Utils";


class AdkCountryHourFactor extends Component {
    constructor() {
        super();

        this.state = {
            isLoading: false,
            factors: {},
            country: '',
            syncData: null,
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleFieldChange = handleFieldChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleSync = this.handleSync.bind(this);
        this.handleAddCountry = this.handleAddCountry.bind(this);
    }

    componentDidMount() {
        this.setState({ isLoading: true });

        API.AdkCountryHourFactor.get().then(factors => {
            this.setState({ factors, isLoading: false })
        });
    }

    handleSave() {
        this.setState({ isLoading: true });

        API.AdkCountryHourFactor.save(this.state.factors).then(() => this.setState({ isLoading: false }));
    }

    handleAddCountry() {
        const factors = { ...this.state.factors };
        factors[this.state.country] = {};

        this.setState({ country: '', factors });
    }

    handleSync() {
        this.setState({ isLoading: true });

        API.Sync([ 'adk-EU', 'adk-US', 'adk-SG' ], 'countryHourFactor')
            .then((res) => {
                this.setState({ isLoading: false, syncData: { res } });

                setTimeout(() => this.setState({ syncData: null }), 10000);
            })
            .catch(err => {
                this.setState({ isLoading: false, syncData: { reqErr: err } });
                setTimeout(() => this.setState({ syncData: null }), 10000);
            });
    }

    handleChange(event) {
        const { name, value:factor } = event.target;
        const [ country, hour ] = name.split('_');
        
        let { factors } = this.state;
        factors = Object.assign({}, factors);
        
        if(!factors[country]) factors[country] = {};

        factors[country][hour] = factor;

        this.setState({ factors });
    }

    render() {
        const usedCountries = Object.keys(this.state.factors);
        const availableCountries = { ...countriesObj };

        usedCountries.forEach(country => delete availableCountries[country]);

        return (
            <Container loading={this.state.isLoading}>
                <Heading title="ADK Day Factor"/>
                <Row>
                    <Col lg={12}>
                        <Row>
                            <Col lg={6}>
                                <Row>
                                    <Col lg={6}>
                                        <SelectWrap
                                            values={availableCountries}
                                            name="country"
                                            onChange={this.handleFieldChange}
                                            value={this.state.country}
                                        />
                                    </Col>
                                    <Col lg={2}>
                                        <Button bsStyle="success" onClick={this.handleAddCountry}>Add</Button>
                                    </Col>
                                </Row>
                            </Col>
                            <Col lg={6}>
                                <div className="pull-right m-b-15">
                                    <Button bsStyle="success" onClick={this.handleSave}>Save</Button>
                                    <Button bsStyle="info" onClick={this.handleSync}> Sync</Button>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <SyncMessage {...this.state.syncData} />

                <div style={{ overflow: 'auto', height: 'calc(100vh - 250px)', width: '100%' }}>
                    <Table factors={this.state.factors} onChange={this.handleChange} />
                </div>
            </Container>
        );
    }
}

export default AdkCountryHourFactor;



// WEBPACK FOOTER //
// ./src/scenes/AdkCountryHourFactor/index.js